export const colocation = {
  title: 'Colocation',
  subtitle: 'Secure your hardware in our state-of-the-art facility',
  features: {
    datacenter: {
      title: 'Modern Data Center',
      description: 'State-of-the-art facility with advanced security'
    },
    connectivity: {
      title: 'Premium Connectivity',
      description: 'Redundant 10G network with low latency'
    },
    security: {
      title: '24/7 Security',
      description: 'Continuous monitoring and access control'
    },
    location: {
      title: 'Location',
      description: 'Via Caldera 21, Milan - Seeweb'
    }
  }
};